import(/* webpackMode: "eager", webpackExports: ["BailoutToCSR"] */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.3.5_@babel+core@7.28.0_babel-plugin-react-compiler@19.0.0-beta-ebf51a3-20250411_6e2ad9269913da3947c072fd8a1251f0/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager", webpackExports: ["PreloadChunks"] */ "/opt/buildhome/repo/node_modules/.pnpm/next@15.3.5_@babel+core@7.28.0_babel-plugin-react-compiler@19.0.0-beta-ebf51a3-20250411_6e2ad9269913da3947c072fd8a1251f0/node_modules/next/dist/shared/lib/lazy-dynamic/preload-chunks.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/components/common/misc/SupportFeedback.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/components/common/ReferralTracker.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/components/layouts/PageTracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NotificationProvider"] */ "/opt/buildhome/repo/packages/shared/src/components/providers/NotificationProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/components/shared/TopNavbar.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/components/ui/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorProvider"] */ "/opt/buildhome/repo/packages/shared/src/contexts/ErrorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CustomNextThemeProvider"] */ "/opt/buildhome/repo/packages/shared/src/providers/customNextThemeProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["InitializerProvider"] */ "/opt/buildhome/repo/packages/shared/src/providers/initializer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MiniKitContextProvider"] */ "/opt/buildhome/repo/packages/shared/src/providers/MinikitProvider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/providers/modalProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PWAProvider"] */ "/opt/buildhome/repo/packages/shared/src/providers/pwaProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QueryProvider"] */ "/opt/buildhome/repo/packages/shared/src/providers/queryClientProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Web3Provider"] */ "/opt/buildhome/repo/packages/shared/src/providers/web3Provider.tsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/packages/shared/src/styles/globals.css");
